import React, { FC, useCallback } from "react";
import { generatePath, useNavigate } from "react-router";
import { Layout, useDevice } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { ProductPreview } from "../../../../../../domain/projections/ProductPreview";
import { useGetOtherLookProducts } from "../../../../behaviors/useGetOtherLookProducts";
import { ProductCarousel } from "../../../../components/productCarousel/ProductCarousel";
import { ProductGallery } from "../../../../components/productGallery/ProductGallery";
import { useStaticInfo } from "../../../../hooks/useStaticInfo";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Routes } from "../../../../routing/routes";

interface OtherLookProductsProps {
  readonly onPressSlide: () => void;
  readonly variantId: string;
  readonly lookId: string;
}

const OtherLookProducts: FC<OtherLookProductsProps> = ({ lookId, variantId, onPressSlide }) => {
  const navigate = useNavigate();
  const { screen } = useDevice();
  const { basePath } = useStaticInfo();
  const { products: otherLookProducts } = useGetOtherLookProducts(lookId, variantId);

  const completeYourLookTitleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.COMPLETE_YOUR_LOOK_TITLE,
  });

  const handleOnPressSlide = useCallback(
    (product: ProductPreview) => {
      navigate(generatePath(`${basePath}/${Routes.PRODUCT_LOOK_DETAIL}`, { variantId: product.id, lookId }), {
        state: { innerNavigation: true },
      });
      onPressSlide();
    },
    [basePath, lookId, navigate, onPressSlide],
  );

  return otherLookProducts.length ? (
    <Layout testID="other-look-products" fullWidth>
      {screen.L ? (
        <ProductGallery
          products={otherLookProducts}
          title={completeYourLookTitleText}
          onPressProduct={handleOnPressSlide}
        />
      ) : (
        <ProductCarousel
          products={otherLookProducts}
          title={completeYourLookTitleText}
          onPressProduct={handleOnPressSlide}
        />
      )}
    </Layout>
  ) : null;
};

export { OtherLookProducts };
